<template>
 <div :class="windowClass">
        <v-row dense no-gutters class="pa-2">
           <v-col cols="12">
             <v-card>
              <v-toolbar dense>
                    <v-icon  left color="primary">mdi-file-multiple</v-icon>MERCHANDISE REPORTS  
                    <v-spacer></v-spacer>
                    <span style="width: 290px">
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date"
                            label="Select Date"
                            append-icon="mdi-calendar"
                            dense
                            hide-details
                            readonly
                            outlined
                            filled
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                         v-model="date" 
                         @input="getMerchandise(), menu = false" 
                         no-title
                         scrollable
                          :events="arrayEvents"
                          event-color="green lighten-1"
                         >
                        </v-date-picker>
                      </v-menu>
                    </span>
                   
                </v-toolbar>
                <v-row dense no-gutters class="pa-2">
                  <v-spacer/>
                   <v-btn v-if="CAN_GENERATE" @click="confirm=true, action='merchandise', confirm_text='Generate merchandise inventory data?'" small :color="fulls.length>0?'error':'secondary'">{{fulls.length>0?'re-GENERATE':'GENERATE'}}</v-btn>
                </v-row>
                
                <table class="print_table3 md-font" width="100%" id="merch-table">
                   <tr>
                      <td :colspan="headers.length" style="background: #d1d1d1;">
                          FULLS CONTENT
                      </td>
                    </tr>
                    <tr>
                      <td v-for="(head,index) in headers" :key="index+'-head'" class="text-center" style="background: #eaeaea;">
                            {{head.text}}
                      </td>
                    </tr>
                    <tr v-for="(full,index) in fulls" :key="index+'-fulls'" class="text-center">
                      <td class="text-left">{{full.code}}</td>
                      <td class="text-left">{{full.description}}</td>
                      <td>{{full.beginning}}</td>
                       <td>{{full.purchase}}</td>
                      <td>{{full.inbound}}</td>
                      <td>{{full.transfer_in}}</td>
                       <td>{{full.transfer_out}}</td>
                       <td>{{full.loaded}}</td>
                       <td style="background: #BAD0FF;">{{full.outbound}}</td>
                       <td style="background: #B7D5CA;">{{full.sold}}</td>
                       <td>{{full.ending}}</td>
                       <td>
                          <input 
                              type="number"
                              :disabled="!CAN_GENERATE"
                                class="va-input pa-1"
                               v-model="full.actual"
                               @change="saveFullsItem(full)"
                              />
                       </td>
                        <td>{{full.ending - full.actual}}</td>
                        <td>
                            <v-icon  small :color="full.remarks?'info':'warning'" @click="action='fulls',full_item=full, textedit=full.remarks, show=true">mdi-file-edit</v-icon>
                        </td>
                    </tr>
                </table>

        <table class="print_table3 md-font" width="100%" id="merchempt-table">
                   <tr>
                      <td :colspan="headers.length" style="background: #d1d1d1;">
                          EMPTIES
                      </td>
                    </tr>
                    <tr>
                      <td v-for="(head,index) in empty_headers" :key="index+'-emp-head'" class="text-center" style="background: #eaeaea;">
                            {{head.text}}
                      </td>
                    </tr>
                    <tr v-for="(empty,index) in empties" :key="index+'-empties'" class="text-center">
                      <td class="text-left">{{empty.code}}</td>
                      <td class="text-left">{{empty.description}}</td>
                      <td>{{empty.beginning}}</td>
                       <td>{{empty.refund}}</td>
                      <td>{{empty.transferred}}</td>
                      <td>{{empty.keep}}</td>
                       <td>{{empty.returned}}</td>
                       <td>{{empty.ending}}</td>
                       <td>{{empty.ending_converted}}</td>
                       <td>
                          <input 
                              type="number"
                                class="va-input pa-1"
                                :disabled="!CAN_GENERATE"
                               v-model="empty.actual"
                               @change="saveEmptiesItem(empty)"
                              />
                       </td>
                        <td>{{empty.ending_converted - empty.actual }}</td>
                        <td>
                            <v-icon  small :color="empty.remarks?'info':'warning'" @click="action='empties',empty_item=empty, textedit=empty.remarks, show=true">mdi-file-edit</v-icon>
                        </td>
                    </tr>
                </table>
                 <table class="print_table3 sm-font" width="100%">
                   <tr>
                      <td  class="text-primary" style="background: #d1d1d1;">
                        <v-row dense v-if="date" no-gutters>
                             Empties Converstion
                              <v-spacer/> 
                            <v-btn small @click="action='convert', confirm_text='Convert complete empties?', confirm=true" color="warning" v-if="conversions.length == 0"><v-icon left>mdi-calculator-variant</v-icon> Convert</v-btn>
                        </v-row>
                      </td>
                    </tr>
                     <tr v-for="(item,i) in conversions" :key="i+'-con'">
                      <td  class="text-info">
                            
                              ({{item.complete_converted * item.bot_per_shell}}) {{item.bot_code}}  
                              and ({{item.complete_converted}})  {{item.shell_code}}  was converted to ({{item.complete_converted}}) {{item.complete_code}} ...
                              - <i class="text-warning">{{item.generated | moment($date_format)}}</i>


                      </td>
                    </tr>
                 </table>

            </v-card>
             <p class="sm-font ma-2" v-if="conversions.length>0">To re-gerenerate the converted data, re-generate the merchandise for the date selected. (note: any edits will be override) </p>
           </v-col>
        </v-row>
        <va-text-edit-form :show="show" :data="textedit" state="updated" @DialogEvent="textEvent"/>
         <va-confirm :show="confirm" cancelbtn="Not Now" okbtn="GENERATE" :text="confirm_text" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      show: false,
      action:'',
      confirm_text:'',
      confirm: false,
      full_item:{},
      empty_item:{},
      textedit:"",
      arrayEvents:null,
      menu: false,
      fulls:[],
      empties:[],
      conversions:[],
      date:null,
      headers: [
          { text: 'Code'},
          { text: 'Description'},
          { text: 'Beginning'},
          { text: 'P.O' },
           { text: 'Inbound'},
          { text: 'Trans. In'},
          { text: 'Trans. Out'},
          { text: 'Loaded'},
            { text: 'Outbound'},
             { text: 'Sold', },
          { text: 'Ending'},
           { text: 'Actual'},
            { text: 'Discrep'},
           { text: 'Remarks'},
        ],
        empty_headers: [
          { text: 'Code'},
          { text: 'Description'},
          { text: 'Beginning'},
          { text: 'Refund'},
          { text: 'Transferred'},
           { text: 'Keeps'},
          { text: 'Returned'},
          { text: 'Ending'},
          { text: 'Converted'},
           { text: 'Actual'},
            { text: 'Discrepancy' },
           { text: 'Remarks'},
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
            this.SET_MENUS()
          this.getMerchandiseLogDate()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      CAN_GENERATE() {
        if(this.$moment().format("YYYY-MM-DD") == this.date) {
          return true
        }
        return true
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setOverlayLoading']),
      cEvent(data) {
        this.confirm = false
        if(data != "cancel") {
            if(this.action == 'merchandise') {
             this.generateMerchandise()
            }
             if(this.action == 'convert') {
              this.generateConversion()
            }
        }
      },
      textEvent(data){
        this.show=false
          if(data.action != 'close') {
            if(this.action == 'fulls') {
              this.full_item.remarks = data.text
              this.saveFullsItem(this.full_item)
            } else {
               this.empty_item.remarks = data.text
              this.saveEmptiesItem(this.empty_item)
            }
          }
      },
     getMerchandiseLogDate() {
        this.$http.post("merchandise/get_log_dates", {}).then(response => {
             response.data.items !=null?this.arrayEvents=response.data.items:this.arrayEvents=[]
            console.log(this.arrayEvents)
            }).catch(e => {
            console.log(e.data)
        })
      },
      generateConversion(){
        this.conversions = []
        this.APPLOADER(true, "Converting complete empties...")
          this.$http.post("merchandise/convert_empties", {from_date: this.date}).then(response => {
            this.GET_RESPONSE(response)
            setTimeout(()=>{this.getMerchandise()},800)
            }).catch(e => {
            console.log(e.data)
        })
      },
      generateMerchandise() {
        this.conversions = []
        this.fulls = []
        this.APPLOADER(true, "Generating Fulls Merchandise...")
          this.$http.post("merchandise/fulls_generate", {from_date: this.date}).then(response => {
            this.GET_RESPONSE(response)
            setTimeout(() => {
              this.generateEmptiesMerchandise()
            }, 1600);
            }).catch(e => {
            console.log(e.data)
        })
      },

     generateEmptiesMerchandise() {
        this.empties = []
        this.APPLOADER(true, "Generating Empties Merchandise...")
          this.$http.post("merchandise/empties_generate", {from_date: this.date}).then(response => {
            this.GET_RESPONSE(response)
            setTimeout(() => {
              this.getMerchandise()
            }, 1000);
            }).catch(e => {
            console.log(e.data)
        })
      },
      getMerchandise() {
        this.fulls = []
         this.APPLOADER(true, "Parsing Fulls Merchandise...")
          this.$http.post("merchandise/fulls_view", {from_date: this.date}).then(response => {
            response.data.items !=null?this.fulls=response.data.items:this.fulls=[]
            setTimeout(()=>{
              this.getEmptyMerchandise()
            },1000)
            }).catch(e => {
            console.log(e.data)
        })
      },
       saveFullsItem(item) {
         item.actual = this.$IsNum(item.actual)
          this.$http.post("merchandise/fulls_save",item).then(response => {
              this.GET_RESPONSE(response)
            }).catch(e => {
            console.log(e.data)
        })
      },
       saveEmptiesItem(item) {
         item.actual = this.$IsNum(item.actual)
          this.$http.post("merchandise/empties_save",item).then(response => {
              this.GET_RESPONSE(response)
            }).catch(e => {
            console.log(e.data)
        })
      },
      getEmptyMerchandise() {
        this.empties = []
         this.APPLOADER(true, "Parsing Empties Merchandise...")
          this.$http.post("merchandise/empties_view", {from_date: this.date}).then(response => {
            response.data.items !=null?this.empties=response.data.items:this.empties=[]
            
            setTimeout(()=>{ this.getConversions() },1000)
            }).catch(e => {
            console.log(e.data)
        })
      },
      getConversions() {
        this.conversions = []
         this.APPLOADER(true, "Checking converted empties...")
          this.$http.post("merchandise/get_converted_empties", {from_date: this.date}).then(response => {
            response.data.items !=null?this.conversions=response.data.items:this.conversions=[]
            setTimeout(()=>{this.APPLOADER(true,'Done...')},800)
            setTimeout(()=>{this.APPLOADER(false,'')},1800)
            }).catch(e => {
            console.log(e.data)
        })
      }
    },
  }
</script>